export const AnchorIntro = () => (
  <section className="surface rounded-2xl p-5 sm:p-8 fade-up" data-testid="hte-anchor">
    <div className="eyebrow">Sauh kerangka · Surah Al-Kahfi</div>
    <p className="mt-3 text-sm text-mute max-w-2xl leading-relaxed">
      HTE berpaut pada pembukaan Surah Al-Kahfi: al-Kitab diturunkan, lurus dan menegakkan nilai, menuntut ilmu, lalu menjadi perhiasan yang memudahkan kehidupan di bumi.
    </p>
  </section>
);
